import type {XlsxRow} from "./types.ts";
import {DateTime} from "luxon";

export function ValueToday({historic}: { historic: XlsxRow[] }) {
    const date = DateTime.now();
    const currentValue = historic.find(r => r.date.toISODate() === date.toISODate())!;
    return (
        <div class="text-center pt-5 col col-12" id="fecha">
            <h2>Valor de la UI a la fecha
                ({date.toLocaleString({
                    weekday: 'long',
                    year: 'numeric',
                    day: '2-digit',
                    month: 'long',
                })}):</h2>
            <h1 class="border p-3 bg-info-subtle text-info">{currentValue?.ui} Pesos Uruguayos</h1>
        </div>
    )
}